import type { Manifest } from '@atlassian/react-loosely-lazy-manifest';

import { MODE } from './constants';

const DEFAULT_CROSS_ORIGIN = undefined;

const DEFAULT_MANIFEST = {
	publicPath: '/',
	assets: {},
};

const DEFAULT_MODE = MODE.HYDRATE;

const DEFAULT_RETRY = 2;

export type Config = {
	crossOrigin: 'anonymous' | 'use-credentials' | undefined;
	environment: 'client' | 'server' | undefined;
	manifest: Manifest;

	markedForPreload: string[] | undefined;
	mode: typeof MODE.HYDRATE | typeof MODE.RENDER;
	modernErrorFallback: boolean;
	onChunkRender(moduleId: string, realFileName: string, defer: number): void;
	react18: boolean;
	retry: number;
	trackDuplicateLazyIds: boolean;
	usePostTaskPhases: boolean;
};

const nullFunction = () => {};

const config: Config = {
	crossOrigin: DEFAULT_CROSS_ORIGIN,
	manifest: DEFAULT_MANIFEST,
	mode: DEFAULT_MODE,
	retry: DEFAULT_RETRY,

	react18: false,
	onChunkRender: nullFunction,
	usePostTaskPhases: false,
	trackDuplicateLazyIds: false,
	modernErrorFallback: false,
	markedForPreload: [],
	environment: undefined,
};

export { MODE };

export const getConfig = (): Config => config;

export const setConfig = (nextConfig: Partial<Config>): void => {
	config.crossOrigin = nextConfig.crossOrigin ?? DEFAULT_CROSS_ORIGIN;
	config.manifest = nextConfig.manifest ?? DEFAULT_MANIFEST;
	config.mode = nextConfig.mode ?? DEFAULT_MODE;
	config.retry = nextConfig.retry ?? DEFAULT_RETRY;
	config.react18 = nextConfig.react18 ?? false;
	config.onChunkRender = nextConfig.onChunkRender ?? nullFunction;
	config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
	config.trackDuplicateLazyIds = nextConfig.trackDuplicateLazyIds ?? false;
	config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
	config.markedForPreload = nextConfig.markedForPreload ?? undefined;
	config.environment = nextConfig.environment ?? undefined;
};
